import React, { useContext } from 'react';
import { List, Pagination, CreateButton, FilterButton, ExportButton, useListContext, useResourceDefinition, useResourceContext, FilterContext } from 'react-admin';

import CardActions from '../layout/CardActions';

const ListActions = (props) => {
	const { bulkActions, selectedIds, onUnselectItems, filters: filtersProp, className, children } = props;
	const { sort, displayedFilters, filterValues, exporter, showFilter, total } = useListContext();
	const resource = useResourceContext(props);
	const { hasCreate } = useResourceDefinition({ resource });
	const filters = useContext(FilterContext) || filtersProp;

	return (
		<CardActions className={className}>
			{bulkActions && React.cloneElement(bulkActions, {
				filterValues,
				resource,
				selectedIds,
				onUnselectItems,
			})}
			{children}
			{filtersProp ? React.cloneElement(filtersProp, {
				resource,
				showFilter,
				displayedFilters,
				filterValues,
				context: 'button',
			}) : filters && <FilterButton />}
			{hasCreate && <CreateButton />}
			{exporter !== false && (
				<ExportButton
					disabled={total === 0}
					resource={resource}
					sort={sort}
					filter={filterValues}
					exporter={exporter}
					maxResults={5000}
				/>
			)}
		</CardActions>
	);
};

const ListPagination = props => <Pagination rowsPerPageOptions={[25, 50, 100]} {...props} />


List.defaultProps = {
	actions: <ListActions />,
	pagination: <ListPagination />,
	perPage: 25,
	sort: { field: 'id', order: 'DESC' },
	exporter: false
};

export default List;
export { ListActions, ListPagination };